<template>
  <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="about">
    <div class="w-100">
      <h1 class="mb-0">Carlos J.
        <span class="text-primary">Infante Ramos</span>
      </h1>
      <div class="subheading mb-5">Sancti Spíritus · CUBA ·
        <a href="mailto:dundivet@gmail.com">dundivet@gmail.com</a>
      </div>
      <p class="lead mb-5">Web technologies lover and Symfony advocator. Fullstack web developer, part-time layout and web designer. Learning enthusiast, open-minded for change. Father of one.</p>
      <div class="social-icons">
        <a href="https://www.linkedin.com/in/dundivet/" title="Linkedin">
          <font-awesome-icon :icon="['fab', 'linkedin-in']" />
        </a>
        <a href="https://github.com/dundivet" title="GitHub">
          <font-awesome-icon :icon="['fab', 'github']" />
        </a>
        <a href="https://profile.codersrank.io/user/dundivet" title="Codersrank">
          <font-awesome-icon :icon="['fas', 'code']" />
        </a>
        <a href="https://www.facebook.com/dundivet" title="Facebook">
          <font-awesome-icon :icon="['fab', 'facebook-f']"/>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  }
}
</script>
